import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../shared/models/jobTypeCourt.model';

import { BsModalService } from 'ngx-bootstrap/modal';
// Quill Editor
// // import { QuillEditorModule } from 'ngx-quill-editor';


import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';
import { JobTypeAffidavit } from '../../../shared/models/jobTypeAffidavit.model';

import { JobServiceRule } from '../../../shared/models/jobServiceRule.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { Project } from 'src/app/shared/models/project';


@Component({
  selector: 'app-edit-job-project-wizard',
  templateUrl: './edit-job-project-wizard.component.html',
  styleUrls: ['./edit-job-project-wizard.component.scss']
})
export class EditJobProjectWizardComponent implements OnInit {




  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_court: any;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: Object;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  job_type_document: Object;
  job_type_document_types: Object;
  sent_job_type_court_id: any;
  job_type_affidavit: Object;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_service_rule: Object;
  project: any;
  @Input() project_id?: number;
  brands: any;

  // public job_fields: Object = { text: 'subject_id', value: 'subject_id' };
  public job_fields: Object = { text: 'job_id', value: 'job_id' };


  public editorConfig = {
    theme: 'snow',
    placeholder: '',
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['link', 'image'],
        ['clean']
      ]
    }
  };
  JSON_job: string;
  job: Object;
  jobs: Object;




  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService,
  ) { }


  ngOnChanges() {
    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);
  this.model = new Project();
  this.project_id = this.count;
 this.model = this.getProject(this.count);
 this.getJobTypes();
 this.getBrands();
 this.getJobsTableData();


  }

  ngOnInit() {
  }





  getProject(project_id) {
    this._demoService.getProject(project_id).subscribe(
       data => { this.project = data; 
        let res = data[0];
        // this.getJob(res.job_id);
       // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);
        // this.getJobTypeCourts(res.job_type_location_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobsTableData(){
    this._demoService.getJobsTableData().subscribe(
      data => {this.jobs = data;
      let res = data[0];
      }
    )
  }

  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        this.job = data;
        let res = data[0];
       /*  this.getJobType(res.job_type_id);
        this.getClientMapping(res.client_id);
        this.getClientInvoice(res.client_invoice_id);
        this.getClientContactSharmans(res.client_contact_id);
        this.getJobSubjectType(res.job_subject_type_id);
        this.getJobPlaintiffType(res.job_plaintiff_type_id);
        this.getJobTypeLocation(res.job_type_location_id);
        this.getJobTypeCourt(res.job_type_court_id);
        this.getJobTypeDocument(res.job_type_document_type_id);
        this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
        this.getJobAgentAssigned(res.job_id);
        this.getReportBrand(res.brand_report_id); // get company brand
        this.getInvoiceBrand(res.brand_invoice_id); // get company invoice brand
        this.getReportBrandUser(res.brand_report_user_id); // get report brand user
 */
        this.JSON_job = JSON.stringify(data);

        // this.newSubject = {
        //   job_id: res.job_id,
        //   job_reference_number: res.job_reference_number,
        //   number_subjects: 1,
        //   existing_subjects_count: this.current_subject_count, // set so that increments in sql correctly
        //   file_number: this.current_subject_count, // adds one in api loop
        //   reference_number: res.reference_number,
        //   created_by: this.gfunc.sessionUserId,
        //   is_active: '1',
        //   job_type_id: res.job_type_id,
        //   job_type_location_id: res.job_type_location_id,
        //   job_type_court_id: res.job_type_court_id,
        //   job_type_document_type_id: res.job_type_document_type_id,
        //   job_type_affidavit_type_id: res.job_type_affidavit_type_id,
        //   job_status: res.job_status_code,
        //   job_subject_type_id: res.job_subject_type_id,
        //   job_service_rule_id: res.job_service_rule_id,
        //   job_service_timeframe_id: res.job_service_timeframe_id,
        //   subject_service_type_id: 1
        //    };
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    // this.model.job_type_location_id = 1;
   // this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }


  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
       data => { this.job_type_court = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeDocument(job_type_document_type_id) {
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
       data => { this.job_type_document = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobTypeAffidavit(job_type_affidavit_type_id) {
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
       data => { this.job_type_affidavit = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   



   getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   updateProject(model) {
    this._demoService.updateProject(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Project Updated');
       // Subject to reload the manager component parent.
       this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error Saving Project!');
         return console.error(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }


   updateJobTypeAffidavit(model) {
    this._demoService.updateJobTypeAffidavit(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Affidavit Type Updated');
       // Subject to reload the manager component parent.
       this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Affidavit!');
        //  return Observable.throw(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }
    


    
    getJobTypeCourts(job_type_location_id) {
      this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
         data => { this.job_type_courts = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeCourtsID(job_type_location_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_location_id = job_type_location_id;
      this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
    
    }


    getJobTypeDocumentTypes(job_type_court_id) {
      this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
         data => { this.job_type_document_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeDocumentTypesID(job_type_court_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_court_id = job_type_court_id;
      this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  
    }

    getBrands() {
      this._demoService.getBrands().subscribe(
         data => { this.brands = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }

}
